import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-stream-source",
  templateUrl: "./stream-source.component.html",
  styleUrls: ["./stream-source.component.scss"]
})
export class StreamSourceDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<StreamSourceDialogComponent>
  ) {}

  get types() {
    return StreamSourceDialogComponent.Types;
  }

  onSelect(type: StreamSourceDialogComponent.Types) {
    this.dialogRef.close(type);
  }
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace StreamSourceDialogComponent {
  export enum Types {
    LOCAL_VIDEO,
    BACKGROUND_MUSIC
  }
}
